import { useState } from "react";
import { ContactAPI } from "../../../api";

const NewsLetter = () => {
    const [successMessage, setSuccessMessage] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await ContactAPI.submitSubscribeForm({ email });
            setSuccessMessage(true);
            setEmail("");
        } catch (err) {
            alert(err?.response?.data?.message || "Subscription failed.");
        } finally {
            setLoading(false);
        }
    };

    if (successMessage) {
        return (
            <p className="text-green-400 font-medium animate-pulse">
                ✨ You're subscribed! Check your inbox soon.
            </p>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="relative flex items-center w-full max-w-md group text-lg">
            <input
                className="w-full bg-white/10 border border-white/20 rounded-full py-3 px-6 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:bg-white/20 transition-all"
                placeholder="Email address"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
            />
            <button
                disabled={loading}
                className="cursor-pointer absolute right-1.5 bg-brand-500 ha:bg-brand-400 text-white px-7 py-2 rounded-full font-bold transition-transform active:scale-95 disabled:opacity-50"
            >
                {loading ? "..." : "Join"}
            </button>
        </form>
    );
};

export default NewsLetter;